<template>
  <q-dialog
    v-model="pagesUtilStore.showModalPCsInstitutional"
    :no-backdrop-dismiss="true"
  >
    <q-card class="midia-app-padding-modal" style="width: 1200px; max-width: 95vw;">

      <div>

        <!-- TABELA -->
        <div
          class="column"
        >
        
            <div class="row q-mb-md">
              <q-input
                outlined
                dense
                class="full-width"
                placeholder="Pesquisar PC (código, nome, cidade, UF...)"
                v-model="searchPcs"
              >
                <template #prepend>
                  <q-icon name="search" />
                </template>
              </q-input>
            </div>

            <div style="width: 100%; overflow-x: auto;">
              <q-table
                ref="qTablePCs"
                :rows="pcStore.pcs"
                row-key="codpontocaptura"
  
                :columns="qTablePCsColumns"
                :visible-columns="qTablePCsVisibleColumns"
  
                selection="multiple"
                v-model:selected="pcStore.selectedPCs"
  
                v-model:pagination="pagination"
                @request="onRequest"
  
                :rows-per-page-options="[10, 50, 100]"
                :loading="loadingTableContents"
  
                flat
                dense
                separator="horizontal"
                class="midia-app-table"
                no-data-label="Nenhum registro encontrado!"
  
                table-style="min-width: 1100px"
              >
  
                <!-- HEADER CUSTOM -->
                <template v-slot:header="props">
                  <q-tr :props="props">
  
                    <!-- checkbox select all -->
                    <q-th auto-width style="text-align: center;">
                      <q-checkbox
                        v-model="props.selected"
                        :color="props.selected ? 'globalAppPrimaryColor' : 'globalAppSecondaryColor2'"
                        :keep-color="!props.selected"
                      />
                    </q-th>
  
                    <q-th
                      v-for="col in props.cols"
                      :key="col.name"
                      :props="props"
                    >
                      <span class="midia-app-title-header-table-lg">
                        {{ col.label }}
                      </span>
                    </q-th>
  
                  </q-tr>
                </template>
  
                <!-- BODY CUSTOM -->
                <template v-slot:body="props">
                  <q-tr :props="props" class="table-body-rows">
  
                    <!-- checkbox row -->
                    <q-td auto-width style="text-align: center;">
                      <q-checkbox
                        v-model="props.selected"
                        :color="props.selected ? 'globalAppPrimaryColor' : 'globalAppSecondaryColor2'"
                        :keep-color="!props.selected"
                      />
                    </q-td>
  
                    <q-td key="codpontocaptura" :props="props">
                      <div class="row items-center no-wrap">
                        <span class="midia-app-label-lg">
                          {{ props.row.codpontocaptura }}
                        </span>
                      </div>
                    </q-td>
  
                    <q-td key="nompontocaptura" :props="props">
                      <span class="midia-app-label-lg">
                        {{ props.row.nompontocaptura }}
                      </span>
                    </q-td>
  
                    <q-td key="nomcidredeautoatndto" :props="props">
                      <span class="midia-app-label-lg">
                        {{ props.row.nomcidredeautoatndto }}
                      </span>
                    </q-td>
  
                    <q-td key="ufredeautoatndto" :props="props">
                      <span class="midia-app-label-lg">
                        {{ props.row.ufredeautoatndto }}
                      </span>
                    </q-td>
  
                    <q-td key="nomsubredeautoatndto" :props="props">
                      <span class="midia-app-label-lg">
                        {{ props.row.nomsubredeautoatndto }}
                      </span>
                    </q-td>
  
                    <q-td key="nomsegmmerclocalptoatndto" :props="props">
                      <span class="midia-app-label-lg">
                        {{ props.row.nomsegmmerclocalptoatndto }}
                      </span>
                    </q-td>
  
                    <q-td key="nomtpmaqautoatndto" :props="props">
                      <span class="midia-app-label-lg">
                        {{ props.row.nomtpmaqautoatndto }}
                      </span>
                    </q-td>
  
                  </q-tr>
                </template>
  
              </q-table>

            </div>

          </div>
        </div>

        <!-- BOTÃO -->
        <div class="row justify-end q-mt-md">
          <c-q-btn
            propBtnLabel="Continuar"
            :propBtnSize="EnumButtonSizes.LARGE_1"
            @click="onContinueBtnClick"
          />
        </div>

        <!-- LOADING -->
        <q-inner-loading
          :showing="pagesUtilStore.showLoading"
          label="Aguarde..."
        />

    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import { ref, watch, computed } from "vue"
import { EnumButtonSizes } from "@/enums/enums"
import { usePCStore } from "@/stores/pcStore"
import { useCampaignStore } from "@/stores/campaignStore"
import { usePagesUtilStore } from "@/stores/pagesUtilStore"
import { PcModel } from "@/models/PcModel"
import { useInstitutionalStore } from "@/stores/institutionalStore"

const pcStore = usePCStore()
const campaignStore = useCampaignStore()
const pagesUtilStore = usePagesUtilStore()

const searchPcs = ref('')

const institutionalStore = useInstitutionalStore()


const loadingTableContents = ref(false)

const pagination = ref({
  page: 1,
  rowsPerPage: 10,
  rowsNumber: 0,
  sortBy: '',
  descending: false
})

/* ✅ COLUNAS PADRONIZADAS */
const qTablePCsColumns = [
  { name: 'codpontocaptura', label: 'Código', field: 'codpontocaptura', align: 'left' },
  { name: 'nompontocaptura', label: 'Nome PC', field: 'nompontocaptura', align: 'left' },
  { name: 'nomcidredeautoatndto', label: 'Cidade', field: 'nomcidredeautoatndto', align: 'left' },
  { name: 'ufredeautoatndto', label: 'UF', field: 'ufredeautoatndto', align: 'left' },
  { name: 'nomsubredeautoatndto', label: 'Subrede', field: 'nomsubredeautoatndto', align: 'left' },
  { name: 'nomsegmmerclocalptoatndto', label: 'Segmento', field: 'nomsegmmerclocalptoatndto', align: 'left' },
  { name: 'nomtpmaqautoatndto', label: 'Tipo Máquina', field: 'nomtpmaqautoatndto', align: 'left' }
]

const qTablePCsVisibleColumns = [
  'codpontocaptura',
  'nompontocaptura',
  'nomcidredeautoatndto',
  'ufredeautoatndto',
  'nomsubredeautoatndto',
  'nomsegmmerclocalptoatndto',
  'nomtpmaqautoatndto'
]

/* ✅ REQUEST SERVER-SIDE */
const updatePagination = (pageNumberApi: number, total: number, size: number) => {
  pagination.value.page = pageNumberApi + 1
  pagination.value.rowsNumber = total
  pagination.value.rowsPerPage = size
}

const onRequest = async ({ pagination }: any) => {
  try {
    loadingTableContents.value = true

    const result = await pcStore.fetchPCs(
      pagination.page - 1,
      pagination.rowsPerPage
    )

    if (result) {
      updatePagination(
        result.pageable.pageNumber,
        result.totalElements,
        result.pageable.pageSize
      )
    }

  } finally {
    loadingTableContents.value = false
  }
}

/* ✅ CONTINUAR */
/*const onContinueBtnClick = () => {
  campaignStore.focusedCampaign.pcs.push(
    ...pcStore.selectedPCs.map(pc => new PcModel(pc))
  )

  campaignStore.focusedCampaign.pcsIds =
    campaignStore.focusedCampaign.pcs.map(p => p.codpontocaptura)

  pagesUtilStore.showModalPCsInstitutional = false
}*/

const onContinueBtnClick = () => {
  const pcsSelecionados = pcStore.selectedPCs.map(
    pc => new PcModel(pc)
  )

  // ✅ continua funcionando para campanhas
  //campaignStore.focusedCampaign.pcs.push(...pcsSelecionados)

  //campaignStore.focusedCampaign.pcsIds =
    //campaignStore.focusedCampaign.pcs.map(p => p.codpontocaptura)

  // ✅ ✅ AGORA O IMPORTANTE (Institucional)
  if (institutionalStore.institutionalDetail) {
    institutionalStore.institutionalDetail.pcs = pcsSelecionados

    institutionalStore.institutionalDetail.pcsIds =
      pcsSelecionados.map(p => p.codpontocaptura)

      
  }

  console.log(pcsSelecionados);
  pagesUtilStore.showModalPCsInstitutional = false
}

watch(
  () => pagesUtilStore.showModalPCsInstitutional,
  (isOpen) => {
    if (isOpen) {
      pagination.value.rowsNumber = pcStore.totalElements
    }
  }
)

watch(searchPcs, async (val) => {
  pagination.value.page = 1

  const isNumero = !isNaN(Number(val))

  pcStore.pcFilter.filterPc.codpontocaptura = isNumero && val ? val : undefined
  pcStore.pcFilter.filterPc.nompontocaptura = !isNumero ? val : undefined

  const result = await pcStore.fetchPCs(0, pagination.value.rowsPerPage)

  if (result) {
    pagination.value.rowsNumber = result.totalElements
  }
})

</script>